import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MainComponent } from './main.component';
import { FullComponent } from '../layouts/full/full.component';
// import { DashboardComponent } from './dashboard/dashboard.component';
import { AuthGuardMain } from '../auth/auth-guard.service';
import { DashboardComponent } from './dashboard/dashboard.component';
import { EditpComponent } from './editp/editp.component';
import { AdminAddUserComponent } from './admin-add-user/admin-add-user.component';
import { AdminAddAdminComponent } from './admin-add-admin/admin-add-admin.component';
import { AdminAddCompanyComponent } from './admin-add-company/admin-add-company.component';
import { AdminAddSchoolComponent } from './admin-add-school/admin-add-school.component';
import { ChangePasswordComponent } from './change-password/change-password.component';


const routes: Routes = [
  // { path: "", redirectTo: "/main/dashboard", pathMatch: "full" },
  {
    path: "main",
    component: MainComponent,
    canActivate: [AuthGuardMain],
    children: [
      { path: "", redirectTo: "/main/upload-video", pathMatch: "full" },
      {
        path: "add-admin",
        component: AdminAddAdminComponent,
      },
      {
        path: "add-user",
        component: AdminAddUserComponent,
      },
      {
        path: "add-companyuser",
        component: AdminAddCompanyComponent,
      },
      {
        path: "add-schooluser",
        component: AdminAddSchoolComponent,
      },
      {
        path: "change-password",
        component: ChangePasswordComponent,
      },
      { path: 'dashboard', loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardModule)},
      { path: 'shorts', loadChildren: () => import('./short-management/short.module').then(m => m.ShortModule)},
      { path: 'analytic', loadChildren: () => import('./analytic-managment/analytic-managment.module').then(m => m.AnalyticModule)},
      { path: 'upload-video', loadChildren: () => import('../main/upload-vedio/upload.module').then(m => m.UploadVedioModule)},
      { path: 'video', loadChildren: () => import('../main/myvideo/myvideo.module').then(m => m.MyvideoModule)},
      { path: 'playlist', loadChildren: () => import('../main/create-playlist/create-playlist.module').then(m => m.CreatePlaylistModule)},
      { path: 'refcode', loadChildren: () => import('../main/refcode/refcode.module').then(m => m.RefCodeModule)},
      { path: 'profile', loadChildren: () => import('../main/myprofile/myprofile.module').then(m => m.ProfileModule)},
      { path: 'edit',component:EditpComponent},
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MainRoutingModule { }
